export * from './queries';
import type { DeliveryMethod } from '@boss/services/client';

import { Sku } from './queries';

export const stockKeys = {
  stockByWarehouseIds: ({ skus, warehouseIds, locale }: { locale: string; warehouseIds: string[]; skus: Sku[] }) => [
    'stockByWarehouseIds',
    locale,
    warehouseIds,
    skus,
  ],
  // Serialized skus keep presence keys (skuid only) stable across quantity edits,
  // while per-line quantity/unit changes produce a new key and thus a new check.
  stockStatus: ({
    skus,
    deliveryMethod,
    shopWarehouseCode,
    locale,
  }: {
    locale: string;
    deliveryMethod: DeliveryMethod;
    shopWarehouseCode?: string | null;
    skus: Sku[];
  }) => ['stockStatus', locale, deliveryMethod, shopWarehouseCode ?? null, skus.map(sku => JSON.stringify(sku))],
};
